import { useRef } from 'react';
import { Link } from 'react-router-dom';

const ROOF_TYPES = [
  {
    title: 'Betontag',
    badge: 'Populært og med god grund',
    desc: 'Betontag kaldes også for betontagsten eller cementtagsten og er en populær form for tagbelægning, som du ser på mange danske huse...',
    image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-6_d670fbbd.webp',
    link: '/ydelser/betontag'
  },
  {
    title: 'Tegltag',
    badge: 'Klassisk løsning med en lang levetid',
    desc: 'Tagsten i ægte tegl af hårdtbrændt ler er en klassisk og velkendt løsning med mange muligheder i forhold til farver og glasur...',
    image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-5_4aa47bc2.webp',
    link: '/ydelser/tegltag'
  },
  {
    title: 'Eternittag',
    badge: 'Danskernes foretrukne tagtype',
    desc: 'Trænger dit hus til et nyt tag? Eternittag er en af de mest anvendte tagløsninger i Danmark – og det er ikke uden grund. Let og robust...',
    image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-4_8223e96d.webp',
    link: '/ydelser/eternittag'
  },
  {
    title: 'Ståltag',
    badge: 'Kvalitet, der er til at betale',
    desc: 'Ståltag er for dig, der vil have den gode kvalitet uden at skulle betale en bondegård. Modstandsdygtige og solide med 50-80 års levetid...',
    image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-6_ffb0a06d.webp',
    link: '/ydelser/staaltag'
  },
  {
    title: 'Tagpap',
    badge: 'Billigere løsning med mange muligheder',
    desc: 'Tagpap er et meget fleksibelt og stærkt tag, som egner sig til de fleste konstruktioner. 100 % tæt og arkitektonisk flot med listedækning...',
    image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-7_458e5882.webp',
    link: '/ydelser/tagpap'
  },
  {
    title: 'Nyt skifertag',
    badge: 'Lang levetid og minimal vedligeholdelse',
    desc: 'Overvejer du et nyt tag, og ønsker du en løsning, der kombinerer æstetik, holdbarhed og minimal vedligeholdelse? Skifertag er et oplagt valg...',
    image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-8_5e8e1de9.webp',
    link: '/ydelser/skifertag'
  },
  {
    title: 'Decra ståltag',
    badge: 'Det prisbevidste og gode valg',
    desc: 'Trænger dit tag til en renovering, eller har du brug for et helt nyt tag? Decra ståltag er en billig kvalitetsløsning med 30 års garanti...',
    image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_fa4df807.webp',
    link: '/ydelser/decra-staaltag'
  },
  {
    title: 'Tagrender',
    badge: 'Vælg de rigtige tagrender til dit hus',
    desc: 'Når du skal vælge tagrender til dit hus, er der et hav af valgmuligheder i både aluzink, zink og kobber. Inkluderet ved nyt tag...',
    image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-1_f03d5c06.webp',
    link: '/ydelser/tagrender'
  }
];

export default function RoofTypesCarousel() {
  const scrollContainerRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 340;
      scrollContainerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.pageX - scrollContainerRef.current.offsetLeft;
    scrollLeft.current = scrollContainerRef.current.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDragging.current = false;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.5;
    scrollContainerRef.current.scrollLeft = scrollLeft.current - walk;
  };

  return (
    <section className="space-y-6 pt-4 pb-2" data-aos="fade-up">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div className="space-y-2 max-w-3xl">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-stone-900 uppercase">
            Mulige tagtyper
          </h2>
          <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
            Valget afhænger af husets stil, budget, lokalplan og dine ønsker til vedligeholdelse og levetid. Hos Dansk Tagbyg tilbyder vi at lægge flere forskellige slags tage, alt efter hvilke muligheder din bolig giver. Læs mere om mulighederne herunder:
          </p>
        </div>

        {/* Navigation pile */}
        <div className="flex items-center gap-2 self-end sm:self-auto shrink-0">
          <button
            type="button"
            onClick={() => scroll('left')}
            className="w-10 h-10 border border-stone-300 hover:border-stone-900 bg-white hover:bg-stone-50 flex items-center justify-center text-stone-700 hover:text-stone-900 transition-colors shadow-xs cursor-pointer"
            aria-label="Forrige tagtype"
          >
            <i className="fa-solid fa-chevron-left text-sm" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            onClick={() => scroll('right')}
            className="w-10 h-10 border border-stone-300 hover:border-stone-900 bg-white hover:bg-stone-50 flex items-center justify-center text-stone-700 hover:text-stone-900 transition-colors shadow-xs cursor-pointer"
            aria-label="Næste tagtype"
          >
            <i className="fa-solid fa-chevron-right text-sm" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {/* Horisontal swipe/scroll karrusel */}
      <div
        ref={scrollContainerRef}
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
        className="flex gap-5 sm:gap-6 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-4 pt-2 cursor-grab active:cursor-grabbing [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
      >
        {ROOF_TYPES.map((type) => (
          <div
            key={type.title}
            className="snap-start min-w-[280px] sm:min-w-[300px] max-w-[320px] flex-shrink-0 flex flex-col justify-between bg-white border border-stone-200 overflow-hidden shadow-sm group hover:border-[#BE0F12] transition-colors"
          >
            <div className="h-44 overflow-hidden bg-stone-100">
              <img
                src={type.image}
                alt={type.title}
                loading="lazy"
                draggable={false}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 pointer-events-none select-none"
              />
            </div>
            <div className="p-5 flex-grow space-y-2">
              <h3 className="text-xl font-extrabold text-stone-900 uppercase">
                {type.title}
              </h3>
              <p className="text-xs font-bold text-[#BE0F12] uppercase tracking-wider">
                {type.badge}
              </p>
              <p className="text-xs text-stone-600 leading-relaxed line-clamp-3">
                {type.desc}
              </p>
            </div>
            <div className="p-5 pt-0">
              <Link
                to={type.link}
                className="block text-center py-2.5 bg-stone-900 group-hover:bg-[#BE0F12] text-white text-xs font-bold uppercase tracking-wider transition-colors"
              >
                Læs mere
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
